import { useApi } from "@/hooks";
import NoSubscriptionsMessage from "@Components/app/notifications/NoSubscriptionsMessage";
import { AppContext, Events } from "@Context/common/general/context";
import { useSubscription } from "@hooks/index";
import { Api } from "@Shared/schemas";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useExclusiveMode } from "../shared/use-exclusive-mode";
import { useNotificationActions } from "../shared/use-notification-actions";
import { useNotificationCandidate } from "../use-notification-candidate";

const id = "NO_ACCESS_SUBSCRIPTION_MODAL";

const NoAccessSubscriptionNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const isExclusiveMode = useExclusiveMode();
  const { handleLogout, handleSelectAccount, handleSelectPlan } = useNotificationActions();
  const { hasActiveSubscription } = useSubscription();
  const userId = state.user.id;
  const hasNoAccount = state.user.noAccount;

  const { call: recoverAccount } = useApi({
    api: Api.Account.RecoverAccount,
    request: {
      user_id: state.user.dbId!,
      stripe_customer_id: state.user.id!
    },
    onSuccess: () => {
      Events.account.refreshCurrentAccount.emit();
    },
  });

  const handleRefreshAccount = useCallback(async () => {
    if (!userId || !hasNoAccount) {
      return;
    }

    await recoverAccount();
  }, [recoverAccount, userId, hasNoAccount]);

  const isActive =
    state.user.hasAllAccessSubscription === false && !hasActiveSubscription && (Boolean(state.account.id) || hasNoAccount) && !isExclusiveMode && state.user.authenticated;

  const render = useCallback(
    () => (
      <NoSubscriptionsMessage
        open={true}
        onSelectPlan={handleSelectPlan}
        onSelectAccount={handleSelectAccount}
        onLogout={handleLogout}
        onRefresh={handleRefreshAccount}
        isUnityEmbedded={state.device.isUnityEmbedded}
      />
    ),
    [handleLogout, handleRefreshAccount, handleSelectAccount, handleSelectPlan, state.device.isUnityEmbedded]
  );

  useNotificationCandidate({
    id,
    priority,
    isActive,
    render,
  });

  return null;
};

export const noAccessSubscriptionNotification = defineNotificationModule({
  id,
  Resolver: NoAccessSubscriptionNotificationResolver,
});
